import React from "react";
import { Route, Shield, Waves, Zap } from "lucide-react";

const CARDS = [
  {
    icon: <Route size={16} />,
    kicker: "Routing engine",
    title: "Best price, always",
    body: "Every quote scans 45+ DEXs and 15+ bridges. Our pathfinder returns the route with the highest guaranteed output.",
    stat: "45+",
    statLabel: "DEXs indexed",
  },
  {
    icon: <Shield size={16} />,
    kicker: "Self-custody",
    title: "Non-custodial by design",
    body: "Your keys never leave your wallet. All transactions are signed locally and executed on-chain — no middleman, no deposits.",
    stat: "0",
    statLabel: "custody risk",
  },
  {
    icon: <Waves size={16} />,
    kicker: "Cross-chain",
    title: "8 networks, one flow",
    body: "Bridge and swap atomically between Ethereum, BSC, Polygon, Arbitrum, Optimism, Base, Avalanche and Solana.",
    stat: "8",
    statLabel: "chains live",
  },
  {
    icon: <Zap size={16} />,
    kicker: "Performance",
    title: "Sub-2s route selection",
    body: "Latency-optimized routing infrastructure surfaces fresh quotes in under two seconds — even for multi-hop cross-chain paths.",
    stat: "1.8s",
    statLabel: "avg route time",
  },
];

export default function Features() {
  return (
    <section id="features" className="mt-16">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-[10.5px] uppercase tracking-[0.28em] text-[var(--accent)] font-semibold">Infrastructure</div>
          <h2 className="text-[22px] font-semibold text-[var(--text)] mt-1">Trader-grade routing. On every chain.</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {CARDS.map((c) => (
          <div key={c.title} className="panel p-4">
            <div className="flex items-center gap-2.5 mb-3 text-[var(--accent)]">
              {c.icon}
              <span className="text-[10.5px] uppercase tracking-[0.22em] text-[var(--text-subtle)] font-semibold">
                {c.kicker}
              </span>
            </div>
            <div className="text-[15px] font-semibold text-[var(--text)] leading-tight">{c.title}</div>
            <div className="mt-2 text-[12.5px] text-[var(--text-muted)] leading-relaxed">
              {c.body}
            </div>
            <div className="mt-4 pt-3 border-t border-[var(--border)] flex items-baseline gap-2">
              <span className="num-md text-[var(--accent)]">{c.stat}</span>
              <span className="text-[11px] text-[var(--text-subtle)] font-mono uppercase tracking-wider">
                {c.statLabel}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
